var map = {
	"./de/warrior-name.png": "4BRX",
	"./en/warrior-name.png": "09Ik",
	"./es/warrior-name.png": "Yvm6",
	"./fr/warrior-name.png": "2F0E",
	"./ja/warrior-name.png": "bZja",
	"./ko/warrior-name.png": "1ATd",
	"./pt/warrior-name.png": "KYoN",
	"./ru/warrior-name.png": "wUKX",
	"./th/warrior-name.png": "JLSW",
	"./zh-Hant/warrior-name.png": "ex62"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4ZJA";